import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";
import { FaCalendarDays, FaBell } from "react-icons/fa6";

const IslamicOccasions = () => {
  const [occasions, setOccasions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOccasions = async () => {
      try {
        const response = await fetch(
          "https://mosque-backend-yfae.vercel.app/allNotice",
        );
        const data = await response.json();
        setOccasions(data);
      } catch (error) {
        console.error("Error fetching occasions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOccasions();
  }, []);

  return (
    <div className="bg-gradient-to-br from-stone-50 via-white to-green-50/30 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto w-full">
        {/* Header Section */}
        <div className="text-center mb-12">
          <Fade direction="up" triggerOnce>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-50 text-emerald-800 text-xs font-semibold uppercase tracking-wider mb-3">
              <FaBell className="animate-pulse" /> Announcements
            </div>
            <h2 className="text-4xl font-extrabold text-green-950 tracking-tight">
              Islamic Occasions & Notices
            </h2>
            <p className="text-gray-500 text-sm mt-2">
              Stay updated with important community events, holy days, and
              upcoming mosque notices.
            </p>
          </Fade>
        </div>

        {/* Notices Stream Container */}
        <div className="space-y-4">
          {loading ? (
            <div className="text-center py-12 text-gray-400 font-medium animate-pulse">
              Syncing notices...
            </div>
          ) : occasions.length > 0 ? (
            occasions.map((event, index) => (
              <Fade key={index} direction="up" delay={index * 100} triggerOnce>
                <div className="group relative bg-white border border-stone-100 rounded-2xl p-5 sm:p-6 shadow-sm transition-all duration-300 hover:shadow-md hover:border-emerald-100 flex flex-col md:flex-row items-start gap-4 md:gap-6">
                  {/* Modern Geometric Date Badge */}
                  <div className="flex items-center gap-3 md:flex-col md:items-center justify-center bg-emerald-50 text-emerald-900 px-4 py-2.5 rounded-xl md:w-28 shrink-0 shadow-inner">
                    <FaCalendarDays className="w-4 h-4 text-emerald-700 md:mb-1" />
                    <span className="font-bold text-sm sm:text-base text-center tracking-tight leading-tight">
                      {event.date}
                    </span>
                  </div>

                  {/* Notice Description Segment */}
                  <div className="flex-1 space-y-2">
                    <h3 className="text-xl font-bold text-gray-900 group-hover:text-emerald-950 transition-colors tracking-tight">
                      {event.title}
                    </h3>
                    <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                      {event.paragraph}
                    </p>
                  </div>

                  {/* Absolute Accent Line Indicator */}
                  <div className="absolute left-0 top-1/4 bottom-1/4 w-1 bg-emerald-700 rounded-r opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>
              </Fade>
            ))
          ) : (
            <div className="text-center py-16 bg-white border border-stone-100 rounded-2xl text-gray-400 shadow-sm font-medium">
              No active announcements found at this time.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IslamicOccasions;
